import { makeIconDef } from "./makeIconDef";
import React from "react";
export var CheckIconDef = {
    check: makeIconDef('check', {
        regular: function () { return React.createElement("path", { d: "M3 11L9 17L21 5", stroke: "currentColor", strokeWidth: "1", strokeLinecap: "round" }); },
        filled: function () { return React.createElement("path", { d: "M3 11L9 17L21 5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }); }
    }),
};
